import { parseCsvFile, type ParseCsvFile } from './parse-csv-file'
import { parseXlsxFile } from './parse-xlsx-file'

const XLSX_EXTENSIONS = ['.xlsx', '.xlsm']
const XLSX_MIME_TYPES = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel.sheet.macroenabled.12',
]

export function isXlsxFile(file: File): boolean {
  const name = file.name.toLowerCase()
  return XLSX_EXTENSIONS.some((ext) => name.endsWith(ext)) || XLSX_MIME_TYPES.includes(file.type)
}

export const parseImportFile: ParseCsvFile = (file) =>
  isXlsxFile(file) ? parseXlsxFile(file) : parseCsvFile(file)
